import React from 'react'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'
import {
  CannabinoidMetaDataItem,
  CreateChildProduct,
  CreateProduct,
  MetaDataReservedKeys,
} from '../ProductStore'

interface Props {
  product: CreateProduct | CreateChildProduct
  cannabinoid: CannabinoidMetaDataItem
  disabled: boolean
  onClick: () => void
}

export class CannabinoidButton extends React.Component<Props> {
  makeCannabinoidsName = () => {
    let thcString: string | null, cbdString: string | null
    const units = this.props.cannabinoid.unit ? this.props.cannabinoid.unit : ''

    if (this.defaultShowMaxMin) {
      const minThc = this.props.cannabinoid.minTHC
      const maxThc = this.props.cannabinoid.maxTHC
      const minCbd = this.props.cannabinoid.minCBD
      const maxCbd = this.props.cannabinoid.maxCBD

      thcString =
        this.nullStringFormatter(minThc?.toString(), units) +
        ' - ' +
        this.nullStringFormatter(maxThc?.toString(), units)

      cbdString =
        this.nullStringFormatter(minCbd?.toString(), units) +
        ' - ' +
        this.nullStringFormatter(maxCbd?.toString(), units)
    } else {
      const thc = this.props.cannabinoid.thc
      const cbd = this.props.cannabinoid.cbd

      thcString = this.nullStringFormatter(thc?.toString(), units)
      cbdString = this.nullStringFormatter(cbd?.toString(), units)
    }

    return 'Cannabinoids: THC: ' + thcString + ', CBD: ' + cbdString
  }

  nullStringFormatter = (metaValue: string | null | undefined, unit: string) => {
    if (metaValue) {
      return metaValue + unit
    } else {
      return 'N/A'
    }
  }

  get defaultShowMaxMin() {
    const showMaxMinFromCannabinoid = this.props.cannabinoid.findMetaData(
      MetaDataReservedKeys.SHOW_MAX_MIN,
    )

    switch (showMaxMinFromCannabinoid?.metaValue) {
      case 'true':
        return true
      case 'false':
        return false
      default:
        return this.props.product.metaData.showMaxMin
    }
  }

  render() {
    return (
      <div className='d-block mr-2 mb-2'>
        <BlazeButton
          titleProps={{ title: this.makeCannabinoidsName() }}
          buttonProps={{
            onClick: this.props.onClick,
            disabled: this.props.disabled,
          }}
        ></BlazeButton>
      </div>
    )
  }
}
